import React, { useEffect, useState } from "react";
import { Button, Card, Tooltip } from "antd";
import DesmosGraphing from "components/UI/Desmos/DesmosGraphing";
import {
  CloseOutlined,
  CalculatorOutlined,
  FullscreenOutlined,
  FullscreenExitOutlined,
  LineChartOutlined,
} from "@ant-design/icons";
// import { copyLink } from "lib/utils/helperMethods";
import { BiReset } from "react-icons/bi";
import DesmosScientific from "components/UI/Desmos/DesmosScientific";
import { actions as experienceReduxActions } from "views/Experiences/redux";
import { useDispatch, useSelector } from "react-redux";
import { calcTypeSelector } from "views/Experiences/selector";
import "../Calculator/Calculator.scss";
import { useTranslate } from "lib/MrTranslate/MrTranslate";

const Calculator = (props) => {
  const { experienceSettings } = props
  console.log("Calculator Props ==>", props);
  let calculator = null;
  const mrIntl  = useTranslate()
  const [graphingCalculator, setGraphingCalculator] = useState();
  const [calcSetting, setCalcSetting] = useState({
    type: "",
    showCalc: false,
  });
  const [calcFullScreen, setCalcFullScreen] = useState(false);
  const styleCalc = calcFullScreen ? "calc-full-screen-height" : "calc-default-height";
  const dispatch = useDispatch();
  const isDesmosScientificCalc = calcSetting.type == "desmos_scientific_calc";
  const calcCardTitle = isDesmosScientificCalc ? mrIntl("Calculator.scientific_calculator") : mrIntl("Calculator.graphing_calculator");
  const calcSwitchTitle = isDesmosScientificCalc ? mrIntl("Calculator.graphing_calculator") : mrIntl("Calculator.scientific_calculator");
  const calcTypeFromRedux = useSelector(calcTypeSelector());
  const calcSwitch = calcSetting.type != "desmos_scientific_calc" ? "desmos_scientific_calc" : "desmos_graphing_calc";
  const className = calcFullScreen
    ? isDesmosScientificCalc
      ? "graphing-calculator-view-full scientific-calc-wrapper"
      : "graphing-calculator-view-full"
    : isDesmosScientificCalc
    ? "scientific-calculator-view"
    : "graphing-calculator-view";

  if (isDesmosScientificCalc) {
    calculator = (
      <DesmosScientific
        isFullScreen={calcFullScreen}
        styleCalc={styleCalc}
      ></DesmosScientific>
    );
  } else {
    calculator = (
      <DesmosGraphing
        setCalculator={setGraphingCalculator}
        styleCalc={styleCalc}
      ></DesmosGraphing>
    );
  }

  useEffect(() => {
    let defaultCalcType = "desmos_scientific_calc";
    if (
      experienceSettings.graphing_calc_enabled &&
      !experienceSettings.calc_enabled
    ) {
      defaultCalcType = "desmos_graphing_calc";
    }
    dispatch(
      experienceReduxActions.setCalcTypeSuccess({ calcType: defaultCalcType })
    );
  }, [])

  const enableToggleCalcButton = experienceSettings.graphing_calc_enabled && experienceSettings.calc_enabled

  const handleCalcSwitch = (calcType) => {
    setCalcSetting({
      ...calcSetting,
      type: calcType,
      showCalc: true,
    });
    dispatch(
      experienceReduxActions.setCalcTypeSuccess({ calcType: calcType })
    );
  };

  function hideCalculator() {
    setCalcSetting({
      ...calcSetting,
      showCalc: !calcSetting.showCalc,
    });
    setCalcFullScreen(false);
  }
  
  function resetDesmos() {
    if (graphingCalculator) {
      graphingCalculator.setBlank();
    }
  }

  return (
    <div className="calculator-view">
      <Tooltip
        title={mrIntl("Calculator.calculator")}
        placement="bottom"
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
      >
        <Button
          shape="circle"
          icon={<CalculatorOutlined />}
          onClick={() => handleCalcSwitch(calcTypeFromRedux)}
        />
      </Tooltip>
      {calcSetting.showCalc && (
        <Card
          title={calcCardTitle}
          className={className}
          extra={[
            !isDesmosScientificCalc && (
              <Tooltip title="Reset">
                <Button
                  className="reset-graphing-response"
                  key="reset-calculator-button"
                  icon={<BiReset />}
                  onClick={() => resetDesmos()}
                  shape="circle"
                ></Button>
              </Tooltip>
            ),
            (enableToggleCalcButton && <Tooltip
              title={calcSwitchTitle}
              placement={calcFullScreen ? "bottom" : "top"}
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
            >
              <Button
                shape="circle"
                className="calc-switch"
                icon={
                  isDesmosScientificCalc ? (
                    <LineChartOutlined />
                  ) : (
                    <CalculatorOutlined />
                  )
                }
                onClick={() => handleCalcSwitch(calcSwitch)}
              />
            </Tooltip>),
            <Tooltip
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              title={mrIntl("Calculator.full_screen")}
              placement={calcFullScreen ? "bottom" : "top"}
            >
              <Button
                type={"default"}
                className="calc-full-screen-button"
                onClick={() => setCalcFullScreen(!calcFullScreen)}
                shape="circle"
                icon={
                  !calcFullScreen ? (
                    <FullscreenOutlined />
                  ) : (
                    <FullscreenExitOutlined />
                  )
                }
              ></Button>
            </Tooltip>,
            <Tooltip
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              title={mrIntl("CommonText.close")}
              placement={calcFullScreen ? "bottom" : "top"}
            >
              <Button
                key="close-calculator"
                className="close-calculator"
                icon={<CloseOutlined />}
                onClick={() => hideCalculator()}
                shape="circle"
              ></Button>
            </Tooltip>,
          ]}
        >
          {calculator}
        </Card>
      )}
    </div>
  );
};

export default Calculator;
